'use client'

import Link from 'next/link'

type Props = { variant?: 'default' | 'minimal' }

export function PortalFooterAuth({ variant = 'default' }: Props) {
  const y = new Date().getFullYear()
  if (variant === 'minimal') {
    return (
      <footer className="portal-footer portal-footer--minimal">
        <span>© {y} SigmaSense</span>
        <span className="portal-footer-dot" aria-hidden>
          ·
        </span>
        <Link href="/privacy" prefetch={false}>
          Privacy
        </Link>
        <span className="portal-footer-dot" aria-hidden>
          ·
        </span>
        <Link href="/terms" prefetch={false}>
          Terms
        </Link>
      </footer>
    )
  }
  return (
    <footer className="portal-footer">
      <div>
        © {y} SigmaSense
        <a href="https://sigmasense.pk" target="_blank" rel="noopener noreferrer">
          sigmasense.pk
        </a>
        <Link href="/privacy" prefetch={false}>
          Privacy
        </Link>
        <Link href="/terms" prefetch={false}>
          Terms
        </Link>
      </div>
    </footer>
  )
}

export function PortalFooterDashboard() {
  const y = new Date().getFullYear()
  return (
    <footer className="portal-footer-dash portal-footer-dash--minimal">
      <span>© {y} SigmaSense</span>
      <span className="portal-footer-dot" aria-hidden>
        ·
      </span>
      <Link href="/privacy" prefetch={false}>
        Privacy
      </Link>
      <span className="portal-footer-dot" aria-hidden>
        ·
      </span>
      <Link href="/terms" prefetch={false}>
        Terms
      </Link>
    </footer>
  )
}
